// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1Hq-1","notes":"Notes_notes__2rqui"};